<template>
  <div>
    <v-dialog :visible.sync="visible" width="900px" @closed="close">
      <div slot="header" class="flex dialog-header">
        <div class="flex-1 title">
          TimeSheet
          <span
            >The week of
            {{ (current / 1000) | dateformatFilter("M/D/YYYY") }}</span
          >
        </div>
        <div class="option">
          <div class="btn-group" style="margin-right: 10px">
            <VueCtkDateTimePicker
              v-model="selectTime"
              :right="true"
              :no-label="false"
              :no-value-to-custom-elem="true"
              :only-date="true"
              :range="true"
              :noShortcuts="true"
              format="YYYY-MM-DD"
              formatted="llll"
            >
              <a class="btn">Select Week</a>
            </VueCtkDateTimePicker>
          </div>
          <div class="btn-group">
            <a class="btn" @click="prevWeek()">&lt;</a>
            <a class="btn" @click="nextWeek()">&gt;</a>
          </div>
          <a class="btn" @click="curWeek()">Current Week</a>
        </div>
      </div>
      <div class="dialog-body">
        <transition name="component-fade" mode="out-in">
          <div class="week-form flex flex-col" :key="ckey">
            <div class="flex-1 flex">
              <div class="week-form-title">This Week</div>
              <div
                class="flex-1"
                v-for="(days, midx1) in weekData"
                :key="midx1"
              >
                <div class="week-form-date" :class="{ other: days.other }">
                  <p>{{ days.day }}</p>
                  <span>{{ days.date }}</span>
                </div>
              </div>
              <div class="flex-1">Total</div>
            </div>

            <div class="flex-1 flex">
              <div class="week-form-title">Start Time</div>
              <div
                class="flex-1"
                v-for="(days, midx2) in weekData"
                :key="'st_' + midx2"
              >
                <VueCtkDateTimePicker
                  v-model="tmpweekData[`${days.timestamp}_start`]"
                  :right="true"
                  :no-label="true"
                  label="Select"
                  :only-time="true"
                  :no-clear-button="false"
                  :id="`st_${days.timestamp}`"
                  format="HH:mm a"
                  formatted="h:mm a"
                  @input="
                    validateSt(
                      tmpweekData[`${days.timestamp}_start`],
                      days.timestamp
                    )
                  "
                ></VueCtkDateTimePicker>
              </div>
              <div class="flex-1">-</div>
            </div>

            <div class="flex-1 flex">
              <div class="week-form-title">End Time</div>
              <div
                class="flex-1"
                v-for="(days, midx3) in weekData"
                :key="'et_' + midx3"
              >
                <VueCtkDateTimePicker
                  v-model="tmpweekData[`${days.timestamp}_end`]"
                  :right="true"
                  :no-label="true"
                  label="Select"
                  :only-time="true"
                  :no-clear-button="false"
                  :id="`et_${days.timestamp}`"
                  format="HH:mm a"
                  formatted="h:mm a"
                  @input="
                    validateEt(
                      tmpweekData[`${days.timestamp}_end`],
                      days.timestamp
                    )
                  "
                ></VueCtkDateTimePicker>
              </div>
              <div class="flex-1">-</div>
            </div>

            <div class="flex-1 flex">
              <div class="week-form-title">Hours</div>
              <div
                class="flex-1"
                v-for="(days, midx4) in weekData"
                :key="'h_' + midx4"
              >
                <!-- {{calcData[`i_${days.timestamp}`]}} -->
                <label
                  class="hour-comfirm"
                  @click="toggleCheck(days.timestamp)"
                  v-if="
                    calcData[`i_${days.timestamp}`] &&
                    calcData[`i_${days.timestamp}`]['rs']
                  "
                >
                  <i
                    class="material-icons align-middle"
                    :class="{
                      active: calcData[`i_${days.timestamp}`]['check'],
                    }"
                    >check_circle</i
                  >
                  <span>{{
                    calcData[`i_${days.timestamp}`]
                      ? calcData[`i_${days.timestamp}`]["rss"]
                      : ""
                  }}</span>
                </label>
              </div>
              <div class="flex-1">{{ total }}</div>
            </div>
          </div>
        </transition>
        <div class="flex items-center company">
          <label>project:</label>
          <div class="flex-1">
            <model-select
              :options="projectOptions"
              v-model="editProject"
              placeholder="Project"
            ></model-select>
          </div>
        </div>
        <div class="flex flex-row items-center supporting">
          <div class="flex-1 form-inline">
            <span class="strong"
              >Any supporting documents. For example if you are a consultant
              using another timesheet software at the client.</span
            >
          </div>
          <div class="supporting-file">
            <div class="form-inline">
              <div class="input-group">
                <div class="input-file">
                  <input
                    id="license"
                    type="file"
                    placeholder="image"
                    @change="onUpload($event)"
                  />
                  <label class="custom-file-label" for="license">{{
                    supportFile.name ? supportFile.name : "Choose file"
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="submit"
          >SAVE TIMESHEET</spinnerButton
        >
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { storagePut, storageGetDownloadUrl } from "@/vendor/firebase";
import { addDoc, updateDocById, setDoc } from "@/vendor/database";
import vDialog from "@/components/public/Dialog";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import moment from "moment-timezone";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import * as utils from "@/utils/utils";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: {
    consultant: { type: Object },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    jobs: {
      type: Array,
    },
    projectOptions: {
      type: Array,
    },
  },
  data() {
    return {
      today: moment(),
      current: {},
      ckey: "",
      weekNum: 0,
      weekData: [],
      tmpweekData: [],
      // minAmax: [],
      calcData: [],
      visible: false,
      total: 0,
      supportFile: {},
      editProject: null,
      submitLoading: false,
      selectTime: null,
    };
  },
  watch: {
    dialogVisible(val) {
      this.visible = val;
      if (val) {
        this.current = moment().startOf("week");
        this.editProject = null;
        this.init();
      }
    },
    selectTime() {
      if (this.selectTime && this.selectTime.start) {
        this.current = moment(this.selectTime.start).startOf("week");
        this.selectTime.start = moment(this.selectTime.start)
          .startOf("week")
          .format("YYYY-MM-DD");
        this.selectTime.end = moment(this.selectTime.start)
          .endOf("week")
          .format("YYYY-MM-DD");
        this.ckey = "i_" + this.current.valueOf();
        this.genData();
      }
    },
  },
  components: {
    vDialog,
    VueCtkDateTimePicker,
    ModelSelect,
    spinnerButton,
  },
  computed: {
    ...mapState(["user"]),
  },
  mounted() {
    moment.updateLocale("en", {
      week: {
        dow: 1, // First day of week is Monday
      },
    });
    moment.tz.setDefault("America/Los_Angeles");
    this.current = moment().startOf("week");
    this.init();
  },
  methods: {
    submit: async function () {
      if (!this.editProject) {
        this.$toasted.global.toast_error({ message: "project not found" });
        return;
      }
      const project = this.projectOptions.find(
        (item) => item.value === this.editProject
      );
      let tmpJob = [];
      let dataFail = false;
      let len = 0;
      const email = this.consultant.email;
      if (!email) {
        this.$toasted.global.toast_error({ message: "user not found" });
        return;
      }
      this.submitLoading = true;
      for (let i in this.calcData) {
        if (this.calcData[i].start && this.calcData[i].end) {
          const timestamp =
            moment(this.calcData[i].start).startOf("day").valueOf() / 1000;
          let j = {
            id: this.tmpweekData[timestamp + "_id"],
            check_in: this.calcData[i].start / 1000,
            check_out: this.calcData[i].end / 1000,
            company: project.company,
            project_id: project.value,
            consultant: email,
            work_type: "timesheet",
            approve: this.calcData[i].check ? this.calcData[i].check : false,
          };
          len++;
          tmpJob.push(j);
        }
      }
      if (dataFail) {
        this.$toasted.global.toast_error({ message: "Illegal data" });
        return;
      }
      let durl = null;
      let fileName = null;
      if (this.supportFile.file) {
        const path = "consultants/" + this.consultant.id + "/";
        fileName =
          "timesheet_the_week_of_" +
          utils.dateformat(this.current / 1000, "M_D_YYYY") +
          "." +
          this.supportFile.file.type.split("/")[1];
        const putresult = await storagePut(
          path,
          fileName,
          this.supportFile.file
        );
        if (!putresult.ok) {
          this.$toasted.global.toast_error({ message: "upload fail" });
          return;
        }
        const getresult = await storageGetDownloadUrl(path + fileName);
        if (getresult.ok) {
          durl = getresult.data;
        }
      }
      for (let i in tmpJob) {
        if (durl) {
          tmpJob[i]["file"] = durl;
          tmpJob[i]["file_name"] = fileName;
        }
        let addResult;
        const id = tmpJob[i].id;
        const approve = tmpJob[i].approve;
        delete tmpJob[i].id;
        delete tmpJob[i].approve;
        if (id) {
          addResult = await updateDocById("jobs", id, tmpJob[i]);
          if (this.user.roles && this.user.roles.admin) {
            const updateResult = await setDoc("job_approves", id, { approve });
          }
        } else {
          addResult = await addDoc("jobs", tmpJob[i]);
          if (this.user.roles && this.user.roles.admin) {
            const doc_id = addResult.data;
            const setResult = await setDoc("job_approves", doc_id, { approve });
          }
        }
        if (addResult.ok) {
          let t = moment.unix(tmpJob[i]["check_in"]).format("YYYY-MM-DD");
          this.$toasted.global.toast_success({ message: t + " add success" });
          this.close();
        }
      }
      this.submitLoading = false;
    },
    onUpload: function (event) {
      const file = event.target.files[0];
      this.$set(this.supportFile, "name", file.name);
      this.$set(this.supportFile, "file", file);
    },
    toggleCheck: function (ts) {
      if (!this.user.roles || !this.user.roles.admin) return;
      let k = "i_" + ts;
      this.$set(this.calcData[k], "check", !this.calcData[k]["check"]);
      this.$forceUpdate();
    },
    countTotal: function () {
      let t = 0;
      for (let k in this.calcData) {
        if (this.calcData[k]["rs"]) t += this.calcData[k]["rs"];
      }
      let duration = moment.duration(t);
      let d = duration.days() > 0 ? duration.days() * 24 : 0;
      let h = duration.hours() > 0 ? duration.hours() : 0;
      let s = d > 0 ? d + h : h;
      let m = duration.minutes() > 0 ? duration.minutes() : 0;
      this.total = (s > 0 ? s + "h" : "") + (m > 0 ? m + "m" : "");
    },
    validateSt: function (val, ts, check = false) {
      let rtm = this.joinTime(val, ts);
      let k = "i_" + ts;
      if (!this.calcData[k]) {
        this.calcData[k] = {};
      }
      this.calcData[k].check = check;
      this.$set(this.calcData[k], "start", rtm);
      if (this.calcData[k]["end"]) {
        if (this.calcData[k]["start"] >= this.calcData[k]["end"]) {
          delete this.calcData[k].rs;
          delete this.calcData[k].rss;
          this.$set(this.tmpweekData, ts + "_start", "");
          this.countTotal();
          this.$toasted.global.toast_error({
            message: "start time can't be >= end time.",
          });
          return;
        }
        this.$set(
          this.calcData[k],
          "rs",
          this.calcData[k]["end"] - this.calcData[k]["start"]
        );
        let duration = moment.duration(this.calcData[k]["rs"]);
        this.$set(
          this.calcData[k],
          "rss",
          (duration.hours() > 0 ? duration.hours() + "h" : "") +
            (duration.minutes() > 0 ? duration.minutes() + "m" : "")
        );
        this.countTotal();
      }
    },
    validateEt: function (val, ts, check = false) {
      let rtm = this.joinTime(val, ts);
      let k = "i_" + ts;
      if (!this.calcData[k]) {
        this.calcData[k] = {};
      }
      this.calcData[k].check = check;
      this.$set(this.calcData[k], "end", rtm);
      if (this.calcData[k]["start"]) {
        if (this.calcData[k]["end"] <= this.calcData[k]["start"]) {
          delete this.calcData[k].rs;
          delete this.calcData[k].rss;
          this.$set(this.tmpweekData, ts + "_end", "");
          this.countTotal();
          this.$toasted.global.toast_error({
            message: "end time can't be <= start time.",
          });
          return;
        }
        this.$set(
          this.calcData[k],
          "rs",
          this.calcData[k]["end"] - this.calcData[k]["start"]
        );
        let duration = moment.duration(this.calcData[k]["rs"]);
        this.$set(
          this.calcData[k],
          "rss",
          (duration.hours() > 0 ? duration.hours() + "h" : "") +
            (duration.minutes() > 0 ? duration.minutes() + "m" : "")
        );
        this.countTotal();
      }
    },
    joinTime: function (val, ts) {
      if (!val) return;
      let tm = moment.unix(ts).format("YYYY-MM-DD") + " " + val;
      const rtm = moment(tm, "YYYY-MM-DD HH:mm a").valueOf();
      return rtm;
    },
    curWeek: function () {
      // if (confirm("This option will clear all filled data. are you sure?")) {
      this.selectTime = null;
      this.current = moment().startOf("week");
      this.ckey = "i_" + this.current.valueOf();
      this.genData();
      // }
    },
    nextWeek: function () {
      // if (confirm("This option will clear all filled data. are you sure?")) {
      this.selectTime = null;
      this.current.add(1, "weeks");
      this.ckey = "i_" + this.current.valueOf();
      this.genData();
      // }
    },
    prevWeek: function () {
      // if (confirm("This option will clear all filled data. are you sure?")) {
      this.selectTime = null;
      this.current.subtract(1, "weeks");
      this.ckey = "i_" + this.current.valueOf();
      this.genData();
      // }
    },
    init() {
      this.selectTime = null;
      this.ckey = "i_" + this.current.valueOf();
      this.genData();
    },
    genData: function () {
      // this.editCompany = null;
      this.editProject = null;
      this.weekData = [];
      this.tmpweekData = [];
      this.calcData = [];
      this.supportFile = [];
      this.total = 0;
      this.weekNum = this.current.weeks();
      let clone = this.current.clone();
      while (clone.week() === this.current.week()) {
        let d = {
          day: clone.format("ddd"),
          date: clone.format("MMM DD"),
          timestamp: clone / 1000,
          other: clone.day() === 0 || clone.day() === 6 ? true : false,
        };
        this.weekData.push(d);
        this.filterCurrent(d.timestamp);
        clone.add(1, "days");
      }
      // console.log(this.weekData)
    },
    filterCurrent: function (ts) {
      if (!this.jobs) return;
      const startTimestamp = ts;
      const endTimestamp =
        moment.unix(startTimestamp).add(1, "days").valueOf() / 1000;
      this.jobs.forEach((item) => {
        if (
          item.check_in >= startTimestamp &&
          item.check_in <= endTimestamp
          // item.work_type == "timesheet"
          //   && item.company == this.editCompany
        ) {
          const start = utils.dateformat(item.check_in, "HH:mm A");
          const end = utils.dateformat(item.check_out, "HH:mm A");
          this.$set(this.tmpweekData, ts + "_start", start);
          this.$set(this.tmpweekData, ts + "_end", end);
          this.$set(this.tmpweekData, ts + "_id", item.id);
          this.$set(this.tmpweekData, ts + "_company", item.company);
          this.validateSt(start, ts, item.approve);
          this.validateEt(end, ts, item.approve);
          // if (item.company && !this.editCompany) {
          //   this.editCompany = item.company;
          // } else if (
          //   item.company &&
          //   this.editCompany &&
          //   item.company !== this.editCompany
          // ) {
          //   this.editCompany = "multicompanies";
          // }
          // if (item.file_name) {
          //   this.$set(this.supportFile, "name", item.file_name);
          // }
        }
      });
    },
    close: function () {
      this.visible = false;
      this.$emit("update:dialogVisible", false);
    },
  },
};
</script>

<style scoped>
.component-fade-enter-active {
  transition: all 0.3s ease;
}

.component-fade-leave-active {
  /*transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
}

.component-fade-enter,
.component-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.dialog-header .title {
  font-size: var(--font-size-3l);
  font-weight: 900;
  color: var(--font-color-lighter);
}

.dialog-header .option {
  text-align: right;
  width: 400px;
  white-space: nowrap;
}

.dialog-header .option .btn {
  margin-left: 5px;
  border-radius: var(--border-radius-l);
  font-size: var(--font-size-2s);
  padding-left: var(--padding);
  padding-right: var(--padding);
}

.dialog-footer {
}

.dialog-footer .btn {
  margin-left: 10px;
  border-radius: var(--border-radius-l);
  font-size: var(--font-size-2s);
}

.week-form {
  background-color: var(--grey-lightest);
}

.week-form > div {
  border-top: 1px solid var(--border-grey-lightest);
}

.week-form > div:last-child {
  border-bottom: 1px solid var(--border-grey-lighter);
}

.week-form > div > div {
  border-left: 1px solid var(--border-grey-lightest);
  padding: var(--padding) var(--padding);
  display: flex;
  align-items: center;
  width: 80px;
}

.week-form > div > div:first-child {
  border-left: 0 none;
}

.week-form-title {
  width: 150px;
  font-weight: 900;
}

.other {
  color: var(--font-color-lightest);
}

.week-form-date {
  flex: 1;
  text-align: right;
}

.week-form-date p {
  margin: 0;
  font-size: var(--font-size-l);
  font-weight: 900;
}

.week-form-date span {
  display: block;
  font-size: var(--font-size-2s);
}

.hour-comfirm {
  vertical-align: middle;
}

.hour-comfirm .material-icons {
  color: var(--font-color-lighter);
  margin-top: -3px;
}

.hour-comfirm .material-icons.active {
  color: var(--blue-light);
}

.supporting {
  margin: var(--margin);
  font-family: avenir-next-block;
  font-size: var(--font-size-l);
  font-weight: 900;
  line-height: 1.5;
}

.supporting-file {
  padding-left: var(--padding-l);
}

.company {
  margin: var(--margin);
  margin-bottom: var(--margin-l);
  font-family: avenir-next-block;
  font-size: var(--font-size-l);
  font-weight: 900;
  line-height: 1.5;
}

.company label {
  width: 150px;
}

/deep/ .date-time-picker {
  margin: -10px;
  width: auto;
}

/deep/ .date-time-picker .field-input {
  padding-right: 30px;
  background-color: transparent;
  border-color: transparent;
  border-radius: 0;
  font-size: var(--font-size-2s);
}

/deep/ .date-time-picker .field-clear-button {
  right: 5px;
}

/deep/ .date-time-picker .custom-button {
  background-color: transparent;
}
</style>
